<template>
  <div class="activityPerson">
    <div class="activity_body">
      <div class="normalFlex">
        <span class="zjx_course_span_1"></span>
        <span class="zjx_course_span_2"></span>
        <p class="zjx_course_p">业务平台</p>
      </div>

      <div class="bg_box">
        <div class="search_type_list">
          <span class="search_type_item newWidth">班级标签 ：</span>
          <div class="search_type_newlist">
            <span :class="ClassName" @click="clickAll">全部</span>
            <span
              :class="
                k == clickNum ? 'search_type_item active' : 'search_type_item'
              "
              v-for="(i, k) in tags"
              :key="k"
              @click="tagClick(k, i.type)"
              >{{ i.name }}</span
            >
          </div>
        </div>
      </div>

      <div class="tecClass">
        <div
          v-for="(item, index) in hotActList"
          class="tecClass_list"
          @click="navtoDetail(item)"
          :key="index"
        >
          <img :src="item.img" :title="item.meetingName" alt="" />
          <div class="tecClass_list__right">
            <p class="title_head">{{ item.meetingName }}</p>
            <div
              style="
                display: flex;
                align-items: center;
                min-height: 51px;
                justify-content: space-between;
              "
            >
              <div>
                <p class="title_p1">{{ item.meetingTime }}</p>
                <p class="title_p2">{{ item.provinceCity }}</p>
              </div>
              <div class="servePaltorm_live">
                <ShowTips
                  v-if="item.statusName"
                  :message="item.statusName"
                ></ShowTips>
                <img
                  v-if="setImgShow(item) === true"
                  src="@/assets/img/webIndex/alive.png"
                  style="height: 23px; width: auto"
                  alt=""
                />
                <img
                  v-else-if="setImgShow(item) === false"
                  src="@/assets/img/webIndex/aCourse.png"
                  style="height: 23px; width: auto"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import store from "@/store";
import mixin from "@/router/mixin";
import { getActivityList } from "@/api/moudles/activities.js";
import ShowTips from "@/components/showTips/index.vue";
export default {
  mixins: [mixin],
  components: {
    ShowTips,
  },
  data() {
    return {
      hotActList: [],
      webSiteUrl: "",
      tags: [
        {
          name: "活动报名",
          type: "1",
        },
        {
          name: "直播",
          type: "2",
        },
        {
          name: "工程项目管理成果网上申报系统",
          type: "3",
        },
        {
          name: "工程项目管理数字化竞赛",
          type: "4",
        },
      ],
      activitiesLives: "",
      clickNum: null,
      ClassName: "active search_type_item",
    };
  },
  created() {
    this.getActivityList();
  },
  mounted() {
    let newConfig = JSON.parse(localStorage.dynamicConfig);
    if (newConfig.website_url) {
      this.webSiteUrl = newConfig.website_url;
    }
  },
  computed: {
    setImgShow() {
      return (item) => {
        if (item.isLive) {
          const startDate = new Date(item.meetingStartTime);
          const endDate = new Date(item.meetingEndTime);
          const currentDate = new Date();

          const isWithinRange =
            currentDate >= startDate && currentDate <= endDate;
          return isWithinRange;
        }
        return null;
      };
    },
  },
  methods: {
    clickAll() {
      this.activitiesLives = "";
      // this.pageNo = 1;
      this.clickNum = null;
      this.ClassName = "search_type_item active";
      this.getActivityList();
    },
    tagClick(k, id) {
      this.clickNum = k;
      this.activitiesLives = id;
      // this.pageNo = 1;
      this.ClassName = "search_type_item";
      this.getActivityList();
    },
    // 获取活动列表
    getActivityList() {
      getActivityList({
        data: {
          type: this.activitiesLives,
        },
        success: (res) => {
          // console.log('热门活动列表', res.data)
          const arr = res.data;
          // &&
          // res.data.sort((value1, value2) => {
          //   if (value1.sort < value2.sort) {
          //     return -1;
          //   } else if (value1.sort > value2.sort) {
          //     return 1;
          //   } else {
          //     return 0;
          //   }
          // });
          this.hotActList = arr.length ? arr : [];
        },
      });
    },
    navtoDetail(item) {
      if (item.outUrl) {
        if (item.outUrl.indexOf("http") !== -1) {
          this.$router.push({
            name: "ifirameView",
            query: {
              url: item.outUrl,
              code: item.meetingCode,
            },
          });
        } else {
          if (this.$phoneSize()) {
            if (item.module == "live") {
              this.$router.push({
                name: "ifirameView",
                query: {
                  // url: `http://localhost:82/sub_activities/pages/live/live?id=${item.outUrl}`,
                  url: `${this.webSiteUrl}/sub_activities/pages/live/live?id=${item.outUrl}`,
                  code: item.meetingCode,
                  webSiteUrl: this.webSiteUrl,
                  outUrl: item.outUrl,
                  modules: item.module,
                },
              });
            } else {
              this.$router.push({
                name: "ifirameView",
                query: {
                  // url: `http://localhost:81/sub_activities/pages/iframeDetail/iframeDetail?id=${item.outUrl}`,
                  url: `${this.webSiteUrl}/sub_activities/pages/iframeDetail/iframeDetail?id=${item.outUrl}`,
                  code: item.meetingCode,
                  webSiteUrl: this.webSiteUrl,
                  outUrl: item.outUrl,
                  modules: item.module,
                },
              });
            }
          } else {
            if (item.module == "live") {
              this.$router.push({
                name: "ifirameView",
                query: {
                  url: `${this.webSiteUrl}/lives/${item.outUrl}`,
                  code: item.meetingCode,
                  webSiteUrl: this.webSiteUrl,
                  outUrl: item.outUrl,
                  modules: item.module,
                },
              });
            } else {
              this.$router.push({
                name: "ifirameView",
                query: {
                  // url: `http://localhost:3000/activities/${item.outUrl}`,
                  url: `${this.webSiteUrl}/activities/${item.outUrl}`,
                  code: item.meetingCode,
                  webSiteUrl: this.webSiteUrl,
                  outUrl: item.outUrl,
                  modules: item.module,
                },
              });
            }
          }
        }
      } else {
        // 会议1;
        if (item.meetingCode == "22791675424589") {
          window.open("http://123.57.205.192/home/index");
          return;
        }
        // 会议2;
        if (item.meetingCode == "44951675671015") {
          window.open("https://jinshuju.net/f/CLq0uQ");
          return;
        }
        if (this.$phoneSize()) {
          this.$router.push({
            name: "phoneActivitiesDetail",
            params: {
              code: item.meetingCode,
            },
          });
        } else {
          this.$router.push({
            name: "activitiesDetail",
            params: {
              code: item.meetingCode,
            },
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.bg_box {
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  padding: 5px 0px;
  margin: 10px 0 20px;
}
.search_type_list {
  display: flex;
  /* align-items: center; */
}

.search_type_list .search_type_item {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  margin-right: 10px;
  padding: 10px;
}

.search_type_list .search_type_item.active {
  color: #2256f6;
  font-weight: 700;
  background: rgba(34, 86, 246, 0.05);
  border-radius: 5px;
}
.search_type_newlist {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

/* 插入标签 */

.servePaltorm_live {
  /* height: 50px; */
  padding: 5px 10px 0 10px;
}
@media screen and (max-width: 750px) {
  .newWidth {
    min-width: 75px;
    margin-right: 0px !important;
  }

  .activityPerson {
    width: 100%;
    background-color: #fff;
    min-height: calc(100vh - 140px);
  }

  .activity_body {
    padding: 10px 20px;
    margin-bottom: 60px;
  }

  .tecClass {
    display: flex;
    flex-flow: column;
  }

  .activitiesList {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
  }

  .activities_list img {
    border-radius: 7px;
    width: 100%;
    height: 120px;
  }

  .tecClass_list {
    cursor: pointer;
    display: flex;
    margin-bottom: 20px;
    min-height: 100px;
    align-items: center;
  }

  .tecClass_list img {
    border-radius: 5px;
    width: 160px;
    height: 100px;
    object-fit: cover;
  }

  .tecClass_list__right {
    display: flex;
    flex-flow: column;
    width: calc(100% - 160px);
  }

  .activities_list {
    cursor: pointer;
    height: 120px;
    border-radius: 7px;
    overflow: hidden;
  }

  .title_p1,
  .title_p2 {
    color: #bbb;
    font-size: 14px;
    margin: 5px 0;
    /* width: 260px; */
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .title_head {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}

@media screen and (min-width: 750px) {
  .activities_list {
    cursor: pointer;
    height: 158px;
    border-radius: 7px;
    overflow: hidden;
  }

  .activityPerson {
    width: 1200px;
    margin: 0 auto;
    background-color: #f7f7f7;
    min-height: calc(100vh - 260px);
  }

  .activity_body {
    padding: 20px 0px;
  }

  .tecClass {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
  }

  .activitiesList {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 30px;
    grid-row-gap: 20px;
    margin-bottom: 40px;
  }

  .tecClass_list {
    cursor: pointer;
    width: 280px;
    min-height: 278px;
    overflow: hidden;
    background-color: #fff;
    margin-bottom: 40px;
    border-radius: 7px;
  }

  .tecClass_list img {
    width: 100%;
    height: 158px;
    object-fit: cover;
  }

  .title_p1,
  .title_p2 {
    color: #bbb;
    font-size: 14px;
    margin: 5px 0;
    /* width: 260px; */
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .title_head {
    width: 260px;
    min-height: 48px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}

/* 非条件编译 */
.normalFlex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.zjx_course_span_1 {
  display: inline-block;
  width: 8px;
  height: 30px;
  background: #d40d16;
}

.zjx_course_span_2 {
  margin-left: 5px;
  display: inline-block;
  width: 4px;
  height: 30px;
  background: #d40d16;
}

.zjx_course_p {
  margin-left: 15px;
  font-family: PingFangSC-Semibold;
  font-size: 24px;
  color: #131415;
  letter-spacing: 0;
  font-weight: 600;
}

.brumd_card {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  padding-left: 20px;
  border-bottom: 2px solid #f5f5f5;
  box-sizing: border-box;
}

.brumd_card span {
  cursor: pointer;
}

.tecClass_list p,
.activities_list p {
  padding-left: 10px;
  padding-right: 10px;
}

.borderClass {
  border: 1px solid #e5e5e5;
  border-radius: 5px;
}
</style>
